import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-16dc58b7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "activity-section" }
const _hoisted_2 = ["href"]
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "empty-content"
}
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon-empty" }, [
  /*#__PURE__*/_createElementVNode("img", { src: "https://static-s.theckb.com/BusinessMarket/Client/userCenter/icon_empty.png" })
], -1))

import { ref, onMounted } from 'vue'
import type { Ref } from 'vue'
import { t } from '@/plugins/i18n'
import type { TabsPaneContext } from 'element-plus'
import { WorkbenchBannerApi, WorkbenchBannerRespDTO } from '@/apis/user'
import { TaEvent, taTrack } from '@/util/buryingPoint'

enum FUNCTION_TYPE {
    /** 重要公告 */
    IMPORTANT_NOTICE = 1,
    /** 热门活动 */
    HOT_ACTIVITY,
    /** 功能更新 */
    FUNCTION_UPDATE
}

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const activitySection = ref([
  {
    label: t('重要公告'),
    labelZh: '重要公告',
    name: FUNCTION_TYPE.IMPORTANT_NOTICE,
    position: 'important_notice'
  },
  {
    label: t('热门活动'),
    labelZh: '热门活动',
    name: FUNCTION_TYPE.HOT_ACTIVITY,
    position: 'popular_activity'
  },
  {
    label: t('功能更新'),
    labelZh: '功能更新',
    name: FUNCTION_TYPE.FUNCTION_UPDATE,
    position: 'feature_update'
  }
])
const activeName: Ref<FUNCTION_TYPE> = ref(FUNCTION_TYPE.IMPORTANT_NOTICE)
const workbanchBannerList: Ref<WorkbenchBannerRespDTO[] | undefined> = ref()
/** 当前banner */
const currentBanner: Ref<WorkbenchBannerRespDTO | undefined> = ref()

const handleClickTab = (tab: TabsPaneContext) => {
  const currentObj = workbanchBannerList.value?.find((item) => item.functionType === tab.props.name)
  const currentTab = activitySection.value?.find((item) => item.name === tab.props.name)

  if (currentObj) {
    currentBanner.value = currentObj
  }
  if (currentTab) {
    taTrack({
      event: TaEvent.BTN_CLICK,
      value: {
        position: currentTab.position,
        banner_name: currentTab.labelZh
      }
    })
  }
}
/** 获取工作台banner */
const getWorkbenchBanner = async () => {
  const res = await WorkbenchBannerApi()
  workbanchBannerList.value = res.data
  if (res.data?.length) {
    activitySection.value = activitySection.value.filter(item => res.data?.map(v => v.functionType).includes(item.name))
    currentBanner.value = res.data?.[0]
    activeName.value = res.data?.[0].functionType as FUNCTION_TYPE
  }
}
/** 点击活动图 */
const handleClickImg = () => {
  const currentTab = activitySection.value?.find((item) => item.name === currentBanner.value?.functionType)
  if (currentTab) {
    taTrack({
      event: TaEvent.BTN_CLICK,
      value: {
        position: currentTab.position,
        banner_name: currentTab.labelZh
      }
    })
  }
}

onMounted(() => {
  getWorkbenchBanner()
})

return (_ctx: any,_cache: any) => {
  const _component_el_tab_pane = _resolveComponent("el-tab-pane")!
  const _component_el_tabs = _resolveComponent("el-tabs")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (workbanchBannerList.value?.length)
      ? (_openBlock(), _createBlock(_component_el_tabs, {
          key: 0,
          modelValue: activeName.value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeName).value = $event)),
          onTabClick: handleClickTab,
          class: "activity-tabs"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activitySection.value, (item) => {
              return (_openBlock(), _createBlock(_component_el_tab_pane, {
                key: item.label,
                label: item.label,
                name: item.name
              }, {
                default: _withCtx(() => [
                  _createElementVNode("a", {
                    target: "_blank",
                    href: currentBanner.value?.dumpUrl,
                    onClick: handleClickImg
                  }, [
                    _createElementVNode("img", {
                      src: currentBanner.value?.img,
                      height: "60",
                      style: {"width":"100%"}
                    }, null, 8, _hoisted_3)
                  ], 8, _hoisted_2)
                ]),
                _: 2
              }, 1032, ["label", "name"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["modelValue"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("span", null, _toDisplayString(_unref(t)('暂无公告')), 1)
        ]))
  ]))
}
}

})